






































import {
  Modal,
  ModalMixin,
  AsyncBtn,
  notify,
} from 'mycorems-app-shared';
import { User, UserRole } from '../../types';
import UserRoles from '../../user-role/UserRoles.vue';
import { isServiceRoleMode } from '../../config';
import invite from '.';

interface Data {
  task: Promise<User>|null,
  firstName: string,
  lastName: string,
  email: string,
  user: User|null,
}

export default ModalMixin.extend({
  components: { Modal, UserRoles, AsyncBtn },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Invite User',
    },
    roleType: String,
  },
  data(): Data {
    return {
      task: null,
      firstName: '',
      lastName: '',
      email: '',
      user: null,
    };
  },
  computed: {
    rolesLabel(): string {
      if (isServiceRoleMode()) {
        return 'roles';
      }
      return 'a role';
    },
    hasRole(): boolean {
      return this.user ? (this.user.roles.length > 0) : false;
    },
  },
  methods: {
    invite() {
      this.task = invite(this.accountId, this.firstName, this.lastName, this.email, this.roleType);
      this.task.then((user) => {
        this.user = user;
        notify.success(`An invitation has been sent to ${this.user.firstName}.`);
        if (this.roleType) {
          this.done();
        }
      });
    },
    assignRole(userRole: UserRole) {
      if (!this.user) return;
      this.user.roles.push(userRole);
    },
    unassignRole(userRole: UserRole) {
      if (!this.user) return;
      const index = this.user.roles.findIndex(ur => ur.id === userRole.id);
      if (index >= 0) {
        this.user.roles.splice(index, 1);
      }
    },
    done() {
      if (!this.user) return;
      this.$emit('ok', this.user);
      this.hide();
    },
  },
});
